import { DownOutlined, GlobalOutlined, UpOutlined } from "@ant-design/icons";
import { useState } from "react";
import "./MobileHeaderDropdown.scss";

export interface MobileDigitalDropdownProps {
  closeDrawer: () => void;
}

export default function MobileDigitalDropdown({closeDrawer} : MobileDigitalDropdownProps) {
  const [isDigitalSubmenuOpen, setDigitalSubmenuOpen] = useState(false);

  function toggleDigitalSubmenu() {
    setDigitalSubmenuOpen(!isDigitalSubmenuOpen);
  }
  
  return (
    <li>
      <a href={"/feature/digital-menu-board-solution.html"} onClick={closeDrawer}>
        <GlobalOutlined />
        Digital
      </a>
      <div className="expand-templates expand-digital" onClick={toggleDigitalSubmenu}>
        {!isDigitalSubmenuOpen && <DownOutlined/>}
        {isDigitalSubmenuOpen && <UpOutlined/>}
      </div>
      {isDigitalSubmenuOpen &&
      <ul className="templates-submenu">
        <li>
          <a className="dsa-app" href={"/feature/digital-menu-board-solution.html"} onClick={closeDrawer}>
            <img src="https://timber.mhmcdn.com/site/marketing/icons/DSARed.svg" alt="Display app icon"/>
            Display App
          </a>
        </li>
        <li>
          <a href={"/feature/why-is-toast-pos-better.html"} target="_blank" rel="noreferrer" onClick={closeDrawer}>
            Toast POS
          </a>
        </li>
        <li>
          <a href={"/feature/menu-qr-code.html"} onClick={closeDrawer}>
            QR Codes
          </a>
        </li>
        <li>
          <a href={"/feature/restaurant-landing-pages.html"} onClick={closeDrawer}>
            Link Pages
          </a>
        </li>
        <li>
          <a href={"/feature/online-menu.html"} onClick={closeDrawer}>
            Online Menus
          </a>
        </li>
      </ul>}
    </li>
  )
}